export default class Application {
    id;
    name;
    description;
    display_on_dashboard;
    client_url;
    icon_url;

    constructor(props) {
        Object.assign(this, props);
    }

    get icon() {
        return this.icon_url;
    }

    set icon(icon) {
        this.icon_url = icon;
    }

    get url() {
        return this.client_url;
    }

    get icon_letters() {
        return this.name ? this.name.substr(0, 1).toUpperCase() +
            this.name.substr(0, 1).toUpperCase() : '';
    }

    hasUrl() {
        return this.url !== null;
    }

}
